<template>
  <div>
    <jd-button type="blueLine" @click="addBanner" :disabled="bannerList.length >= limitNum"
      >添加banner（{{ bannerList.length }}/{{ limitNum }}）</jd-button
    >
    <jd-table
      :tableInfo="tableInfo"
      :tableData="bannerList"
      v-show="bannerList.length > 0"
      class="mt16"
      style="width: 70%"
    >
      <template #bannerUrlSlot="{ row }">
        <el-image
          class="banner-image"
          v-if="row.bannerUrl"
          :src="row.bannerUrl"
          :preview-src-list="[row.bannerUrl]"
        >
        </el-image>
      </template>
      <template #goShopUrlSlot="{ row }">
        <div v-if="row.goShopSetting == 0">进入店铺首页</div>
        <div v-else-if="row.goShopSetting == 1">跳转指定小程序</div>
        <div v-else-if="row.goShopSetting == 2">进入指定链接</div>
      </template>
      <template #operationSlot="{ row, rowIndex }">
        <div>
          <jd-button
            type="blueText"
            @click="moveUp(row, rowIndex)"
            v-if="rowIndex > 0"
            >上移</jd-button
          >
          <jd-button
            type="blueText"
            @click="moveDown(row, rowIndex)"
            v-if="rowIndex < bannerList.length - 1"
            >下移</jd-button
          >
          <jd-button type="blueText" @click="editBanner(row, rowIndex)">编辑</jd-button>
          <jd-button type="blueText" @click="deleteBanner(rowIndex)"
            >删除</jd-button
          >
        </div>
      </template>
    </jd-table>
    <jd-dialog
      :title="isEdit ? '编辑' : '添加'"
      width="800px"
      :visible.sync="isShow"
      destroy-on-close
      @close="isShow = false"
      @comfirm="saveBanner"
      sureText="保存"
    >
      <el-form :model="bannerForm" ref="bannerForm" label-width="120px">
        <el-form-item label="banner图片:" prop="bannerUrl" required>
          <div class="banner-box">
            <uploadCom :imgUrl.sync="bannerForm.bannerUrl" :extensions="['.jpg','.jpeg','.png','.gif']" accept=".jpg,.png,.jpeg,.gif" :pw="690" :ph="150" :limitSize="1"/>
            <div>
              <div class="upload-tip ml8">尺寸：690px*150px</div>
              <div class="upload-tip ml8">格式：JPEG、PNG、GIF（不超过1M）</div>
            </div>
          </div>
        </el-form-item>
        <jumpLinkCom v-model="bannerForm" />
      </el-form>
    </jd-dialog>
  </div>
</template>
<script>
import uploadCom from "./commCustomizationSet/uploadCom.vue";
import jumpLinkCom from "./jumpLinkCom.vue";
export default {
  components: {
    uploadCom,
    jumpLinkCom,
  },
  props: {
    limitNum: {
      type: Number,
      default: 6,
    },
    list: {
      type: Array,
      default: () => [],
    },
    tableInfo: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentIndex: 0,
      isShow: false,
      bannerForm: {
        bannerUrl: "",
        goShopSetting: 0,
        goShopAppId: "",
        goShopUrl: "",
      },
      isEdit: false,
    };
  },
  computed: {
    bannerList: {
      get() {
        return this.list;
      },
      set(val) {
        this.$emit("update:list", val);
      },
    },
  },
  watch: {},
  mounted() {},
  methods: {
    saveBanner() {
      if (!this.bannerForm.bannerUrl) {
        this.$message.warning("请上传banner图片");
        return;
      }
      if (this.bannerForm.goShopSetting == 1 && !this.bannerForm.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.bannerForm.goShopSetting == 2) {
        if (!this.bannerForm.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.bannerForm.goShopUrl.startsWith("https://") ||
          !this.bannerForm.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      if(this.isEdit) {
        this.$set(this.bannerList,this.currentIndex, {...this.bannerForm});
      } else {
        this.bannerList.push({...this.bannerForm});
      }
   
      this.isShow = false;
    },
    addBanner() {
      if (this.bannerList.length >= this.limitNum) {
        this.$message.warning(`最多只能添加${this.limitNum}个banner`);
        return;
      }

      this.isShow = true;
      this.isEdit = false;
      this.bannerForm.bannerUrl = "";
      this.bannerForm.goShopSetting = 0;
      this.bannerForm.goShopAppId = "";
      this.bannerForm.goShopUrl = "";
    },
    moveUp(row, rowIndex) {
      this.bannerList.splice(rowIndex, 1);
      this.bannerList.splice(rowIndex - 1, 0, row);
    },
    moveDown(row, rowIndex) {
      this.bannerList.splice(rowIndex, 1);
      this.bannerList.splice(rowIndex + 1, 0, row);
    },
    editBanner(row, rowIndex) {
      this.isEdit = true;
      this.isShow = true;
      this.currentIndex = rowIndex;
      this.bannerForm = { ...row };
    },
    deleteBanner(rowIndex) {
      this.bannerList.splice(rowIndex, 1);
    },
  },
};
</script>
<style lang="scss" scoped>
.banner-image {
  width: 100px;
}
.banner-box {
  display: flex;
  align-items: flex-end;
  .upload-tip {
    font-size: 14px;
    line-height: normal;
    color: #999999;
  }
}
</style>
